import React, { Component } from 'react';
import Question from '../components/Question';
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');

class QuestionContainer extends Component {

    findThematique(id){
        var themeObject = {
            id: null,
            label: null
        };

        for(var i=0; i<= this.props.themeList.length; i++){
            if(this.props.themeList[i].id === id){
                themeObject = this.props.themeList[i];
                break;
            }
        }

        return themeObject;
    }

    render(){
        var currentIndex = this.props.index;
        var currentAnswerSelected= this.props.handleAnswerSelected;
        var currentAnswers = this.props.currentAnswers;
        var items = this.props.questionList.map((question, index) => {
            if(index === currentIndex || index === (currentIndex - 1)){
                var thematique = this.findThematique(question.thematique);
                return(
                    <Question
                        key={index}
                        question={question.question}
                        thematique={thematique}
                        answerList={question.answerList}
                        questionIndex={index}
                        handleAnswerSelected={currentAnswerSelected}
                        enabled={index === currentIndex}
                        currentAnswer={currentAnswers[index] !== undefined ? currentAnswers[index] : null}
                    />
                )
            }else{
                return ('');
            }

        });
        var banner = '';
        if(this.props.imgBanner !== ''){
            banner = this._getLogoWithBanner();
        }else{
            banner = this._getLogoWithoutBanner();
        }
        return (
            <div className="isg_panel isg_question_container isg_bg_base">
                <div className="isg_panel_content">
                    {banner}
                </div>
                <ReactCSSTransitionGroup
                    transitionName="isg_question"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={500}>
                    {items}
                </ReactCSSTransitionGroup>
            </div>
        );
    }

    _getLogoWithBanner(){
        return (
            <div className="isg_logo">
                <img src={this.props.imgBanner} alt="" />
            </div>
        );
    }

    _getLogoWithoutBanner(){
        return (
            <div className="isg_logo"></div>
        );
    }
}

QuestionContainer.propTypes = {
    questionList: React.PropTypes.array.isRequired,
    themeList: React.PropTypes.array.isRequired,
    questionCount: React.PropTypes.number.isRequired,
    index: React.PropTypes.number.isRequired,
    handleAnswerSelected: React.PropTypes.func.isRequired,
    currentAnswers: React.PropTypes.array.isRequired,
    imgBanner: React.PropTypes.string
};

export default QuestionContainer;


/** WEBPACK FOOTER **
 ** ./src/components/QuestionContainer.js
 **/